import React, { useContext } from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import { FREQUENCY_MONTHLY, FREQUENCY_ONCE, FREQUENCY_WEEKLY } from '../../../../../../models/donationsNew';
import DonationContext from '../../../../../../context/DonationContext/DonationContext';
import { DONATION_TYPE_SD } from '../../../../../../actions/donationNew';

const timeColumnSx = {
  padding: '2px',
  width: '100px',
};
const receiverColumnSx = {
  width: '200px',
  padding: '2px 6px 2px 6px',
};

const AllPickupsTheSameSeparator = ({ frequency, allPickupsTheSame, totalStackedPickups }) => {
  const { donationType } = useContext(DonationContext);

  return (
    <TableHead>
      <TableRow sx={{ height: '36px' }}>
        {frequency === FREQUENCY_WEEKLY && (
          <TableCell align="center" sx={{ padding: '2px', width: '60px' }}>
            Day
          </TableCell>
        )}
        {frequency === FREQUENCY_MONTHLY && (
          <>
            <TableCell align="center" sx={{ padding: '2px', width: '60px' }}>
              Every
            </TableCell>
          </>
        )}
        {totalStackedPickups >= FREQUENCY_WEEKLY && (
          <>
            {!allPickupsTheSame && (
              <TableCell align="center" sx={{ width: '1%', whiteSpace: 'nowrap', padding: '2px 6px 2px 6px' }}>
                Rescuer#
              </TableCell>
            )}
          </>
        )}
        <TableCell align="center" sx={timeColumnSx}>
          Begin
        </TableCell>
        <TableCell align="center" sx={timeColumnSx}>
          End
        </TableCell>

        {[DONATION_TYPE_SD].includes(donationType) && (
          <TableCell align="center" sx={timeColumnSx}>
            #Rescuers
          </TableCell>
        )}

        <TableCell
          align="center"
          sx={{
            padding: '2px',
            width: '160',
            whiteSpace: 'nowrap',
            maxWidth: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          Rescuer Notes
        </TableCell>

        {[DONATION_TYPE_SD].includes(donationType) && (
          <TableCell align="center" sx={receiverColumnSx}>
            Receiver
          </TableCell>
        )}

        {[DONATION_TYPE_SD].includes(donationType) && frequency !== FREQUENCY_ONCE && (
          <TableCell align="center" sx={receiverColumnSx}>
            Adopter
          </TableCell>
        )}

        {[DONATION_TYPE_SD].includes(donationType) && frequency === FREQUENCY_ONCE && (
          <TableCell align="center" sx={receiverColumnSx}>
            Rescuer
          </TableCell>
        )}
        <TableCell align="center" sx={{ width: '10px', padding: '2px 6px 2px 6px' }} />
      </TableRow>
    </TableHead>
  );
};

export default AllPickupsTheSameSeparator;
